// extracted by mini-css-extract-plugin
export var acceptButton = "_11-5";
export var fullContent = "_11-4";
export var link = "_11-6";
export var linkIcon = "_11-7";
export var sideContent = "_11-3";
export var sideImage = "_11-2";
export var sideImageWrapper = "_11-1";
export var splitLayout = "_11-0";